import React from 'react';
import styles from './styles.module.scss';
import classNames from 'classnames';
import icCopy from 'assets/svg/ic_copy.svg';
import { formatType, rentedTimeSince } from '../../../utils';
import { useTooltip } from '@profile/src/Components/TooltipProvider';
import { TooltipDirection } from '@profile/src/Components/TooltipProvider/Tooltip';
import { ellipsisMiddle } from '@profile/src/utils/text';
import Text from '@profile/src/Components/Text';
import { webImageUri } from '@profile/src/utils/uri';
import { copyToClipboard } from '@profile/src/utils/copyToClipboard';

const HeroItem = ({
  className,
  item
}) => {
  const tooltip = useTooltip();
  const copyRef = React.useRef(null);

  const onPress = position => {
    tooltip.show('Copied', position, TooltipDirection.BOTTOM, {
      backgroundColor: '#261858',
      textColor: '#fff',
      delay: 1500
    });
  };

  const renderAddress = address => {
    if (address) {
      return /*#__PURE__*/React.createElement("div", {
        ref: copyRef,
        onClick: () => {
          copyToClipboard('item.fromAddress');

          if (copyRef.current) {
            const rect = copyRef.current.getBoundingClientRect();
            onPress({
              top: rect.top + document.documentElement.scrollTop + 30,
              left: rect.left + document.documentElement.scrollLeft + rect.width / 2
            });
          }
        },
        className: styles.addressId
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.code
      }, ellipsisMiddle(item.renterAddress, 15)), /*#__PURE__*/React.createElement("img", {
        className: styles.icon,
        src: icCopy
      }));
    }

    return '------';
  };

  return /*#__PURE__*/React.createElement("div", {
    key: item.id.toString(),
    className: classNames(styles.item, className)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.row
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.label
  }, "Item"), /*#__PURE__*/React.createElement("div", {
    className: styles.wrapBox
  }, !!item.imageAvatar && /*#__PURE__*/React.createElement("img", {
    className: styles.boxImg,
    src: webImageUri(item.imageAvatar),
    alt: item.tokenName
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.heroInfo
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.wrapName
  }, /*#__PURE__*/React.createElement(Text, {
    numberOfLines: 1,
    className: styles.name
  }, item.tokenName, " - ", item.skinName)), /*#__PURE__*/React.createElement("span", {
    className: styles.tokenId
  }, "#", item.refId)))), /*#__PURE__*/React.createElement("div", {
    className: styles.row
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.label
  }, "status / time"), /*#__PURE__*/React.createElement("div", {
    className: styles.wrapValue
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.type
  }, formatType(item.state)), /*#__PURE__*/React.createElement("span", {
    className: styles.rentedTime
  }, rentedTimeSince(item.lastModified)))), /*#__PURE__*/React.createElement("div", {
    className: styles.row
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.label
  }, "Rental number"), /*#__PURE__*/React.createElement("div", {
    className: styles.wrapValue
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.value
  }, item.rentBattles, " match(es)"))), /*#__PURE__*/React.createElement("div", {
    className: styles.row
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.label
  }, "Address ID"), /*#__PURE__*/React.createElement("div", {
    className: styles.wrapAddress
  }, renderAddress(item.renterAddress))));
};

export default HeroItem;